module.exports = __webpack_public_path__ + "static/media/programmer.721672af.jpg";